import { ajaxController } from "./controller/AjaxController";
import { PagedResult } from "../DTOs/Common/PagedResult";
import { BlastMonitorDTO, ComplianceLimitDTO, SaveBlastMonitorRequest, SaveComplianceLimitRequest } from "../DTOs/DrillBlast/MonitoringDTO";

class BlastMonitorsAjax {
  private _ajaxController = ajaxController;
  private _endpoint = "/BlastMonitors";

  public getMonitors() {
    return this._ajaxController.get<PagedResult<BlastMonitorDTO>>(this._endpoint, {});
  }

  public addMonitor(request: SaveBlastMonitorRequest) {
    return this._ajaxController.post<SaveBlastMonitorRequest, BlastMonitorDTO>(this._endpoint, request);
  }

  public updateMonitor(monitorId: number, request: SaveBlastMonitorRequest) {
    return this._ajaxController.put<SaveBlastMonitorRequest, BlastMonitorDTO>(`${this._endpoint}/${monitorId}`, request);
  }

  public getLimits() {
    return this._ajaxController.get<PagedResult<ComplianceLimitDTO>>(`${this._endpoint}/limits`, {});
  }

  public addLimit(request: SaveComplianceLimitRequest) {
    return this._ajaxController.post<SaveComplianceLimitRequest, ComplianceLimitDTO>(`${this._endpoint}/limits`, request);
  }

  public updateLimit(limitId: number, request: SaveComplianceLimitRequest) {
    return this._ajaxController.put<SaveComplianceLimitRequest, ComplianceLimitDTO>(`${this._endpoint}/limits/${limitId}`, request);
  }
}

export const blastMonitorsAjax = new BlastMonitorsAjax();
